import { useParams } from 'react-router-dom';
import galleryMasterclass from '../mocks/galleryMasterclass.json';
import galleryShowcase from '../mocks/galleryShowcase.json';
import galleryEditorials from '../mocks/galleryEditorials.json';
import { useMemo } from 'react';
import Masonry from 'react-masonry-css';
import 'react-photo-view/dist/react-photo-view.css';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import Breadcrumb from '../components/Breadcrumb';
import TitlePage from '../components/TitlePage';

const Gallery = () => {
    const { id, section } = useParams();
    const album = useMemo(() => {
        if (section === 'training') return galleryMasterclass.find(item => item.id === id);
        if (section === 'showcase') return galleryShowcase.find(item => item.id === id);
        if (section === 'editorials') return galleryEditorials.find(item => item.id === id);
    }, [id, section]);

    if (!album) return <p>Caricamento immagini...</p>;

    return (
        <>
            <Breadcrumb history={album.titlePage.history} current={album.titlePage.current} />
            <section id='careercoach' className='services'>
                <TitlePage title={album.titlePage.current} />
                <div className='container'>
                    <PhotoProvider>
                        <Masonry
                            breakpointCols={{ default: 3, 800: 2, 500: 1 }}
                            className='my-masonry-grid'
                            columnClassName='my-masonry-grid_column'
                            data-aos='fade-up'
                            data-aos-delay='100'
                        >
                            {(album?.pictures ?? []).map((item, index) => (
                                <div key={index} className='masonry-item'>
                                    <PhotoView src={item.path}>
                                        <img
                                            className='img-fluid'
                                            src={item.path}
                                            alt={`Immagine ${index + 1}`}
                                            style={{ cursor: 'pointer' }}
                                        />
                                    </PhotoView>
                                </div>
                            ))}
                        </Masonry>
                    </PhotoProvider>
                </div>
            </section>
        </>
    );
};
export default Gallery;
